export const FETCH_LANDING_CONFIG = "FETCH_LANDING_CONFIG";
export const SET_LANDING_CONFIG = "SET_LANDING_CONFIG";
